var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useMemo } from "react";
import { gql, useLazyQuery } from "@apollo/client";
import { NOOP_QUERY } from "../constants";
import { entityFieldFormQueryFragment } from "../utils/entity-field-form-query-fragment";
import { includes, pickBy, sortBy } from "lodash";
import { graphql } from "@shapeable/graphql";
import { entitySelectDefaultTransform } from "../entities/entity-select";
import { entityNormalizedField, toArray } from "@shapeable/utils";
import { useEntityTypeDefinitionsQuery } from "./use-entity-type-definitions-query";
export var useEntityFormQuery = function (_a) {
  // 1. get the entity type definitions needed
  var e_1, _b;
  var entityTypeName = _a.entityTypeName,
    type = _a.type,
    id = _a.id,
    _c = _a.fields,
    fields = _c === void 0 ? [] : _c;
  var entityTypeNames = [entityTypeName];
  var otherEntityTypeNames = [];
  try {
    // Partial<Record<EntityTypeName, EntityTypeDefinition>> = {};
    for (var fields_1 = __values(fields), fields_1_1 = fields_1.next(); !fields_1_1.done; fields_1_1 = fields_1.next()) {
      var fieldDefn = fields_1_1.value;
      if (fieldDefn.formFieldType === 'linkedJunction') {
        // for junction fields, we also need the definitions for the entityTypeName of those fields, so we know what metadata to pull
        otherEntityTypeNames.push(fieldDefn.entityTypeName);
        entityTypeNames.push(fieldDefn.entityTypeName);
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (fields_1_1 && !fields_1_1.done && (_b = fields_1.return)) _b.call(fields_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
  var entityTypeDefinitionResult = useEntityTypeDefinitionsQuery(entityTypeNames);
  var entityTypeDefinition = entityTypeDefinitionResult.entityTypeDefinitions[entityTypeName];
  var oneName = entityTypeDefinition === null || entityTypeDefinition === void 0 ? void 0 : entityTypeDefinition.oneName;
  var supportingEntityTypeDefinitions = pickBy(entityTypeDefinitionResult.entityTypeDefinitions, function (defn) {
    return !!otherEntityTypeNames.includes(defn.name);
  });
  // we only need to load existing fields if this is an update, otherwise just NOOP it.
  var shouldFetchRecord = type === 'Update' && oneName;
  var fetchPolicy = shouldFetchRecord ? 'cache-first' : 'cache-only';
  // here, we can also query for the select options we need
  var linkedFields = fields.filter(function (fieldDefn) {
    return includes(["linked", "linkedMultiple"], fieldDefn.formFieldType);
  });
  var linkedJunctionFields = fields.filter(function (fieldDefn) {
    return fieldDefn.formFieldType === 'linkedJunction';
  });
  var junctionFragments = linkedJunctionFields.reduce(function (acc, junctionFieldDefn) {
    var junctionEntityDefinition = supportingEntityTypeDefinitions[junctionFieldDefn.entityTypeName];
    var fragment = graphql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      ", " { \n        ", "\n      }\n    "], ["\n      ", " { \n        ", "\n      }\n    "])), junctionFieldDefn.name, junctionEntityDefinition ? junctionEntityDefinition.formFields.map(function (fieldDefn) {
      if (fieldDefn.formFieldType === 'linked' || fieldDefn.formFieldType === 'linkedMultiple') {
        return graphql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", " { ...EntityValueFields }"], ["", " { ...EntityValueFields }"])), fieldDefn.name);
      }
      return entityFieldFormQueryFragment(fieldDefn);
    }).join('\n') : ' ');
    acc.push(fragment);
    return acc;
  }, []).join('\n');
  var selectQueries = linkedFields.reduce(function (acc, fieldDefn) {
    var query = graphql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      all", " { ...EntitySelectFields }\n    "], ["\n      all", " { ...EntitySelectFields }\n    "])), fieldDefn.entityTypeNamePlural);
    acc.push(query);
    return acc;
  }, []).join('\n');
  var QUERY = oneName && graphql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    query EntityFormQuery($id: ID!) {\n      ", "(id: $id) {\n        id\n        name\n        ", "\n        ", "\n      }\n      ", "\n    }\n  "], ["\n    query EntityFormQuery($id: ID!) {\n      ", "(id: $id) {\n        id\n        name\n        ", "\n        ", "\n      }\n      ", "\n    }\n  "])), oneName, fields.map(function (fieldDefn) {
    return entityFieldFormQueryFragment(fieldDefn);
  }).join('\n'), junctionFragments, selectQueries);
  var _d = __read(useLazyQuery(shouldFetchRecord ? gql(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), QUERY) : gql(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), NOOP_QUERY), {
      fetchPolicy: fetchPolicy,
      variables: {
        id: id
      }
    }), 2),
    fetch = _d[0],
    _e = _d[1],
    data = _e.data,
    loading = _e.loading,
    error = _e.error;
  // 2. Fetch the data once we have enough info
  React.useEffect(function () {
    if (shouldFetchRecord) {
      fetch();
    }
  }, [shouldFetchRecord]);
  // here, we prepare any linked or linked multiple fields with select options, and values appropriate for the select boxes
  var _f = useMemo(function () {
      return {
        fieldData: __spreadArray(__spreadArray([], __read(linkedFields), false), __read(linkedJunctionFields), false).reduce(function (acc, fieldDefn) {
          var _a;
          if (fieldDefn.formFieldType === 'linkedJunction') {
            acc[fieldDefn.name] = (_a = data === null || data === void 0 ? void 0 : data[oneName]) === null || _a === void 0 ? void 0 : _a[fieldDefn.name];
          } else {
            // field data will contain options for the select fields. These will be set against the 'data' prop of the form-field SPEC, so it knows what options to show in the selects 
            var optionsData = (data === null || data === void 0 ? void 0 : data["all".concat(fieldDefn.entityTypeNamePlural)]) || [];
            acc[fieldDefn.name] = sortBy(optionsData, entityNormalizedField('name'));
          }
          return acc;
        }, {}),
        fieldValues: linkedFields.reduce(function (acc, fieldDefn) {
          var _a;
          // field values are set here which can be sent to the initial form state. 
          var valuesData = (_a = data === null || data === void 0 ? void 0 : data[oneName]) === null || _a === void 0 ? void 0 : _a[fieldDefn.name];
          // TODO - CLEAN THIS UP, too much inconsitency in the entity select api.... argh. 
          // These values should probably be transformed by the select itself, not here.
          if (fieldDefn.formFieldType === 'linkedMultiple') {
            acc[fieldDefn.name] = toArray(valuesData || []).map(entitySelectDefaultTransform);
          }
          if (fieldDefn.formFieldType === 'linked') {
            acc[fieldDefn.name] = entitySelectDefaultTransform(valuesData);
          }
          return acc;
        }, {})
      };
    }, [data === null || data === void 0 ? void 0 : data[oneName]]),
    fieldData = _f.fieldData,
    fieldValues = _f.fieldValues;
  return {
    data: (data === null || data === void 0 ? void 0 : data[oneName]) || null,
    fieldData: fieldData,
    fieldValues: fieldValues,
    supportingEntityTypeDefinitions: supportingEntityTypeDefinitions,
    entityTypeDefinition: entityTypeDefinition,
    loading: loading || entityTypeDefinitionResult.loading,
    error: error
  };
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;